import { Component, OnInit } from '@angular/core';
import { FormGroupExt } from '../../../../form-ext/form-group.ext';
import { AbstractControl, Validators } from '@angular/forms';
import { FormBuilderExt } from '../../../../form-ext/form-builder.ext';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { ToastService } from '../../../../../common-modules/services/toast.service';
import { UsersService } from '../../../users/services/users.service';
import { AuthService } from '../../services/auth.service';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    standalone: false,
})
export class ForgotPasswordComponent implements OnInit {
    public formGroup: FormGroupExt;
    public isLoading = false;

    constructor(
        public formBuilder: FormBuilderExt,
        protected readonly http: HttpClient,
        public router: Router,
        private toastService: ToastService,
        private usersService: UsersService,
        private authService: AuthService,
    ) {}

    public get EmailControl(): AbstractControl | null {
        return this.formGroup?.group.get('email');
    }

    ngOnInit(): void {
        this.formGroup = this.formBuilder.groupExt(
            {
                email: ['', [Validators.required, Validators.email]],
            },
            {},
            {
                email: {
                    required: $localize`Email is required`,
                    email: $localize`Please enter a valid email address`,
                },
            },
        );
    }

    public requestPasswordReset(): void {
        if (!this.formGroup.group.valid) {
            return;
        }

        this.isLoading = true;
        const email = this.EmailControl?.value;

        this.usersService.forgotPassword(email).subscribe({
            next: () => {
                this.isLoading = false;
                this.toastService.showSuccess('Password reset link sent. Please check your email.', { duration: 5000 });
                this.router.navigate(['/login']);
            },
            error: (error) => {
                this.isLoading = false;
                this.toastService.showError(error.error?.message || 'Failed to send reset link. Please try again.', { duration: 3000 });
            },
        });
    }
}
